import * as notificationTypes from '../../consts/app/notificationTypes';
import * as loaderNames from '../../consts/loader/loaderNames';
import helpers from '../../utils/helpers';

export const SET_IS_APP_LOADING = 'app/global/SET_IS_APP_LOADING';
export const SET_IS_LOADER_VISIBLE = 'app/global/SET_IS_LOADER_VISIBLE';
export const SET_IS_BLUETOOTH_AVAILABLE = 'app/global/SET_IS_BLUETOOTH_AVAILABLE';
export const SET_NOTIFICATION = 'app/global/SET_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'app/global/REMOVE_NOTIFICATION';
export const REMOVE_NOTIFICATION_TYPE = 'app/global/REMOVE_NOTIFICATION_TYPE';
export const SET_LAYOUT = 'app/global/layout/SET_LAYOUT';
export const HIDE_ALL_LOADERS = 'app/global/HIDE_ALL_LOADERS';
export const SET_IS_NETWORK_ONLINE = 'app/global/SET_IS_NETWORK_ONLINE';
export const LOGOUT_CLEAR_DATA = 'app/global/LOGOUT_CLEAR_DATA';
export const SET_IS_RECONNECT_GUIDE_AVAILABLE = 'app/global/SET_IS_RECONNECT_GUIDE_AVAILABLE';
export const SET_IS_START_AUTO_SYNC = 'app/global/SET_IS_START_AUTO_SYNC';
export const SET_IS_DOUBLE_REGISTRATION = 'app/global/SET_IS_DOUBLE_REGISTRATION';
export const SET_IS_REGISTRATION_WAS = 'app/global/SET_IS_REGISTRATION_WAS';
export const SET_SCP_CHECK_IN_PROGRESS = 'app/global/SET_SCP_CHECK_IN_PROGRESS';
export const SET_IS_HOLDER_REGISTER_FAILED = 'app/global/SET_IS_HOLDER_REGISTER_FAILED';
export const SET_IS_SKIP_REGISTRATION = 'app/global/SET_IS_SKIP_REGISTRATION';
export const SET_IS_FWU_PAGE = 'app/global/SET_IS_FWU_PAGE';
export const SET_ERROR_PAGE_TYPE = 'app/global/SET_ERROR_PAGE_TYPE';
export const CLEAR_ERROR_PAGE_TYPE = 'app/global/CLEAR_ERROR_PAGE_TYPE';
export const REMOVE_ALL_NOTIFICATIONS = 'app/global/REMOVE_ALL_NOTIFICATIONS';
export const REMOVE_ALL_SUCCESS_NOTIFICATIONS = 'app/global/REMOVE_ALL_SUCCESS_NOTIFICATIONS';
export const SET_SHOW_SUCCESS_NOTIFICATIONS = 'app/global/SET_SHOW_SUCCESS_NOTIFICATIONS';
export const SET_IS_CONFIG_INITIALIZED = 'app/global/SET_IS_CONFIG_INITIALIZED';
export const SET_WAS_SHOWN_LEVIA_GET_STARTED_NOTIFICATION = 'app/global/SET_WAS_SHOWN_LEVIA_GET_STARTED_NOTIFICATION';
export const SET_IS_AEM_FLEX_BATTERY_WARNING_VISIBLE = 'app/global/SET_IS_AEM_FLEX_BATTERY_WARNING_VISIBLE';
export const SET_NAVIGATION_TARGET = 'app/global/SET_NAVIGATION_TARGET';

export default function reducer(
    state = {
        isAppLoading: true,
        isConfigInitialized: false,
        loaders: [],
        errorPageType: undefined,
        notifications: [],
        isShowSuccessNotifications: true,
        isBluetoothAvailable: undefined,
        isReconnectGuideEnabled: true,
        isStartAutoSync: false,
        isNetworkOnline: true,
        isScpCheckInProgress: false,
        isHolderRegisterFailed: false,
        isSkipRegistration: false,
        isDoubleRegistration: false,
        isRegistrationWas: false,
        isFwuPage: false,
        isAemFlexBatteryWarningVisible: false,
        wasShownLeviaGetStartedNotification: false,
        navigationTarget: {
            target: undefined,
            type: undefined,
            hasAlreadyBeenRedirectedToPairingPage: undefined,
        },
    },
    action
) {
    switch (action.type) {
        case SET_IS_APP_LOADING: {
            const isAppLoading = action.payload;

            return {...state, isAppLoading};
        }
        case SET_IS_CONFIG_INITIALIZED: {
            const isConfigInitialized = action.payload;

            return {...state, isConfigInitialized};
        }
        case SET_IS_LOADER_VISIBLE: {
            const {name, text, isVisible, isTransparent} = action.payload;
            const {loaders} = state;
            let loadersNew = [...loaders];

            if (isVisible) {
                loadersNew.push({name, text, isTransparent});
            } else {
                loadersNew = loaders.filter((e) => e.name !== name);
            }

            return {...state, loaders: loadersNew};
        }
        case SET_IS_BLUETOOTH_AVAILABLE: {
            const isBluetoothAvailable = action.payload;

            return {...state, isBluetoothAvailable};
        }
        case SET_NOTIFICATION: {
            const {type, text, testId, notificationType, autoFocus, customId, isForcedDisplay} = action.payload;
            const {notifications, isShowSuccessNotifications} = state;

            if (type === notificationTypes.SUCCESS && !isShowSuccessNotifications && !isForcedDisplay) {
                return state;
            }

            const notificationsNew = [...notifications];

            if (notificationsNew.some((el) => el.text === text)) return state;

            const notification = {
                notificationId: customId ? customId : helpers.guid(),
                type,
                text,
                testId,
                notificationType,
                autoFocus,
                isForcedDisplay,
            };

            notificationsNew.push(notification);

            return {...state, notifications: notificationsNew};
        }
        case SET_SHOW_SUCCESS_NOTIFICATIONS: {
            return {
                ...state,
                isShowSuccessNotifications: action.payload,
            };
        }
        case REMOVE_NOTIFICATION: {
            const {notificationId} = action.payload;
            const {notifications} = state;
            const notificationsNew = notifications.filter(
                (notification) => notification.notificationId !== notificationId
            );

            return {...state, notifications: notificationsNew};
        }
        case REMOVE_NOTIFICATION_TYPE: {
            const {notificationType} = action.payload;
            const {notifications} = state;
            const notificationsNew = notifications.filter(
                (notification) => notification.notificationType !== notificationType
            );

            return {...state, notifications: notificationsNew};
        }
        case REMOVE_ALL_SUCCESS_NOTIFICATIONS: {
            const {notifications} = state;
            const notificationsNew = notifications.filter(
                (notification) => notification.isForcedDisplay || notification.type !== notificationTypes.SUCCESS
            );

            return {...state, notifications: notificationsNew};
        }
        case REMOVE_ALL_NOTIFICATIONS: {
            return {...state, notifications: []};
        }
        case HIDE_ALL_LOADERS: {
            return {...state, loaders: []};
        }
        case SET_LAYOUT: {
            const layout = action.payload;

            return {...state, layout};
        }
        case SET_IS_NETWORK_ONLINE: {
            return {
                ...state,
                isNetworkOnline: action.payload,
            };
        }
        case LOGOUT_CLEAR_DATA: {
            return {
                ...state,
                isAppLoading: false,
            };
        }
        case SET_IS_RECONNECT_GUIDE_AVAILABLE: {
            return {
                ...state,
                isReconnectGuideEnabled: action.payload,
            };
        }
        case SET_IS_START_AUTO_SYNC: {
            return {
                ...state,
                isStartAutoSync: action.payload,
            };
        }
        case SET_IS_DOUBLE_REGISTRATION: {
            return {
                ...state,
                isDoubleRegistration: action.payload,
            };
        }
        case SET_IS_REGISTRATION_WAS: {
            return {
                ...state,
                isRegistrationWas: action.payload,
            };
        }
        case SET_SCP_CHECK_IN_PROGRESS: {
            return {
                ...state,
                isScpCheckInProgress: action.payload,
            };
        }
        case SET_IS_HOLDER_REGISTER_FAILED: {
            return {
                ...state,
                isHolderRegisterFailed: action.payload,
            };
        }
        case SET_IS_SKIP_REGISTRATION: {
            return {
                ...state,
                isSkipRegistration: action.payload,
            };
        }
        case SET_IS_FWU_PAGE: {
            return {
                ...state,
                isFwuPage: action.payload,
            };
        }
        case SET_ERROR_PAGE_TYPE: {
            const {errorPageType} = state;

            if (errorPageType) return state;

            return {
                ...state,
                errorPageType: action.payload,
            };
        }
        case CLEAR_ERROR_PAGE_TYPE: {
            return {
                ...state,
                errorPageType: undefined,
            };
        }
        case SET_WAS_SHOWN_LEVIA_GET_STARTED_NOTIFICATION: {
            return {
                ...state,
                wasShownLeviaGetStartedNotification: action.payload,
            };
        }
        case SET_IS_AEM_FLEX_BATTERY_WARNING_VISIBLE: {
            return {
                ...state,
                isAemFlexBatteryWarningVisible: action.payload,
            };
        }
        case SET_NAVIGATION_TARGET: {
            return {
                ...state,
                navigationTarget: action.payload,
            };
        }
        default:
            return state;
    }
}

export const setIsAppLoaded = () => ({
    type: SET_IS_APP_LOADING,
    payload: false,
});

export const setIsConfigInitialized = () => ({
    type: SET_IS_CONFIG_INITIALIZED,
    payload: true,
});

const setNotification = (props) => {
    const {text, type, testId, notificationType, autoFocus, customId, isForcedDisplay} = props;

    return {
        type: SET_NOTIFICATION,
        payload: {text, type, testId, notificationType, autoFocus, customId, isForcedDisplay},
    };
};

export const setLayout = (layout) => ({type: SET_LAYOUT, payload: layout});
export const setNotificationSuccess = (text, testId, notificationType, autoFocus, customId) =>
    setNotification({text, type: notificationTypes.SUCCESS, testId, notificationType, autoFocus, customId});

// use this function if you need to show success notification despite of any failure screens(e.g., to show that network status is online)
export const setForcedSuccessNotification = (text) =>
    setNotification({text, type: notificationTypes.SUCCESS, isForcedDisplay: true});
export const setNotificationFailed = (text, testId, customId) =>
    setNotification({
        text,
        type: notificationTypes.FAILED,
        testId,
        customId,
    });
export const setNotificationInfo = (text, testId, notificationType, customId) =>
    setNotification({text, type: notificationTypes.INFO, testId, notificationType, customId});

export const setShowSuccessNotifications = (data) => ({
    type: SET_SHOW_SUCCESS_NOTIFICATIONS,
    payload: data,
});

export const removeNotification = (notificationId) => ({
    type: REMOVE_NOTIFICATION,
    payload: {notificationId},
});

export const removeNotificationType = (notificationType) => ({
    type: REMOVE_NOTIFICATION_TYPE,
    payload: {notificationType},
});

export const removeAllNotifications = () => ({
    type: REMOVE_ALL_NOTIFICATIONS,
});

export const removeAllSuccessNotifications = () => ({
    type: REMOVE_ALL_SUCCESS_NOTIFICATIONS,
});

export const hideAllLoaders = () => ({type: HIDE_ALL_LOADERS});

export const logoutClearData = () => ({type: LOGOUT_CLEAR_DATA});
export const setIsReconnectGuideAvailable = (data) => ({type: SET_IS_RECONNECT_GUIDE_AVAILABLE, payload: data});
export const setIsStartAutoSync = (data) => ({type: SET_IS_START_AUTO_SYNC, payload: data});
export const setScpCheckInProgress = (data) => ({type: SET_SCP_CHECK_IN_PROGRESS, payload: data});
export const setHolderRegisterFailed = (data) => ({type: SET_IS_HOLDER_REGISTER_FAILED, payload: data});

export const setIsDoubleRegistration = (data) => ({
    type: SET_IS_DOUBLE_REGISTRATION,
    payload: data,
});

export const setIsRegistrationWas = (data) => ({
    type: SET_IS_REGISTRATION_WAS,
    payload: data,
});

export const setIsSkipRegistration = (data) => ({type: SET_IS_SKIP_REGISTRATION, payload: data});

export const showLoader = (props) => {
    const name = typeof props === 'string' ? props : props?.name;
    const {text, isTransparent} = props || {};

    return setIsLoaderVisible({name, text, isVisible: true, isTransparent});
};

export const hideLoader = (name) => {
    return setIsLoaderVisible({name, isVisible: false});
};

export const showDeviceSettingsLoader = ({
    name = loaderNames.DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER,
    isTransparent = true,
} = {}) =>
    showLoader({
        name,
        isTransparent,
    });

export const hideDeviceSettingsLoader = (name = loaderNames.DEVICE_SETTINGS_DEVICE_SETTINGS_CHANGE_LOADER) =>
    hideLoader(name);

const DEFAULT_LOADER_NAME = 'default';

export const setIsLoaderVisible = ({name = DEFAULT_LOADER_NAME, text, isVisible, isTransparent}) => {
    return {type: SET_IS_LOADER_VISIBLE, payload: {name, text, isVisible, isTransparent}};
};

export const setIsNetworkOnline = (data) => ({type: SET_IS_NETWORK_ONLINE, payload: data});
export const setIsBluetoothAvailable = (data) => ({type: SET_IS_BLUETOOTH_AVAILABLE, payload: data});
export const setIsFwuPage = (data) => ({type: SET_IS_FWU_PAGE, payload: data});

export const setErrorPageType = (data) => ({type: SET_ERROR_PAGE_TYPE, payload: data});
export const clearErrorPageType = () => ({type: CLEAR_ERROR_PAGE_TYPE});

export const setWasShownLeviaGetStartedNotification = (data) => ({
    type: SET_WAS_SHOWN_LEVIA_GET_STARTED_NOTIFICATION,
    payload: data,
});

export const setIsAemFlexBatteryWarningVisible = (isVisible) => ({
    type: SET_IS_AEM_FLEX_BATTERY_WARNING_VISIBLE,
    payload: isVisible,
});

export const setNavigationTarget = (navigationTarget) => ({
    type: SET_NAVIGATION_TARGET,
    payload: navigationTarget,
});
